// Helper to extract image from HTML string
const extractImageFromHtml = (htmlString) => {
  if (!htmlString) return null;
  try {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(htmlString, 'text/html');
    
    // Find all img tags
    const imgs = Array.from(htmlDoc.querySelectorAll('img'));
    for (const img of imgs) {
      const src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
      
      // Filter out tracking pixels, emojis, and avatars to get the real featured image
      if (src && src.startsWith('http') && !src.includes('avatar') && !src.includes('1x1') && !src.includes('emoji') && !src.includes('smilies')) {
        return src;
      }
    }
  } catch (e) {
    console.error("Error parsing HTML for image:", e);
  }
  return null;
};

export const fetchFeed = async (targetFeed = 'https://sulit.ph/feed/') => {
  try {
    // Use rss2json API: It specializes in bypassing security blocks on standard WordPress feeds
    const res = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(targetFeed)}`);
    if (!res.ok) throw new Error('Network response was not ok');
    
    const data = await res.json();
    if (data.status !== 'ok') {
      throw new Error('RSS parser API returned an error');
    }
    
    const articles = data.items.map(item => {
      // 1. Try provided thumbnail from the API
      let image = item.thumbnail;
      
      // 2. Try standard RSS enclosure
      if (!image && item.enclosure && item.enclosure.link && item.enclosure.type && item.enclosure.type.startsWith('image/')) {
        image = item.enclosure.link;
      }
      
      // 3. Deep extract from the actual article HTML body
      if (!image && item.content) {
        image = extractImageFromHtml(item.content);
      }
      
      // 4. Fallback extract from description HTML
      if (!image && item.description) {
        image = extractImageFromHtml(item.description);
      }

      // Generate a clean, text-only summary from the HTML
      const parser = new DOMParser();
      const summaryDoc = parser.parseFromString(item.content || item.description || '', 'text/html');
      let summary = (summaryDoc.body.textContent || '').replace(/\s+/g, ' ').substring(0, 160).trim();
      if (summary.length >= 160) summary += '...';

      // Parse date safely (rss2json returns YYYY-MM-DD HH:MM:SS)
      const dateStr = item.pubDate ? item.pubDate.replace(' ', 'T') : '';
      const parsedDate = new Date(dateStr);
      const pubDate = !isNaN(parsedDate) ? parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Recent';

      return {
        id: item.guid || item.link,
        title: item.title || 'Untitled',
        link: item.link || '#',
        author: item.author || 'Sulit.ph',
        pubDate,
        image: image || null,
        summary,
        categories: item.categories || []
      };
    });

    return articles;
  } catch (error) {
    console.error('Error fetching feed:', error);
    return [];
  }
};